import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_CLOSE_TO_ED} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {ExecutiveDirectorCloseToRankContent} from './ExecutiveDirectorCloseToRankContent';
import reportPayload from './reportPayload';

export const ExecutiveDirectorCloseToRankReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      // @ts-expect-error TS(2322): Type '{ title: any; description: any; contentProps... Remove this comment to see the full error message
      title={tt('title', 'Close to Executive Director')}
      description={tt(
        'description',
        'These Coaches are almost to Executive Director! Help them get there!',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={ExecutiveDirectorCloseToRankContent}
    />
  );
};

export default withHOC(
  withTranslation('report.executiveDirectorCloseToRankReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_CLOSE_TO_ED,
    popoverContentProps: {},
  }),
)(ExecutiveDirectorCloseToRankReport);
